import { Icon, MockAvatar, MockBubble, MockRail } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * Hình minh hoạ cửa sổ app Desktop + một thông báo nổi trên màn hình.
 *
 * KHÔNG dùng `MockFrame` của `@nexa/ui`: khung đó khoá bóng `shadow-hero-frame` (đen 50%, vẽ cho
 * nền navy của hero), còn section này nền trắng. Đè bóng qua `className` là đặt hai utility cùng
 * thuộc tính cạnh nhau — `cn()` không phải tailwind-merge. Khung ở đây dùng bóng của khung mock
 * nền sáng (`#collab`).
 *
 * Cả khối `aria-hidden`: chữ trong mock không mang thông tin nào mà h2 + lead chưa nói.
 *
 * Thông báo nổi nằm TRONG mép khung ở mọi khổ dưới `lg`, và chỉ thò ra ngoài khung 16px từ `lg`
 * — lúc đó gutter của `Container` đã ≥ 26px nên nó không bao giờ gây cuộn ngang. Từ `lg` nó hạ
 * xuống vùng trống của khung chat: ở 1024 khung hẹp, đặt cao hơn là che mất tên kênh.
 */
export function DesktopMock() {
  const copy = useCopy();
  const mock = copy.download.mock;

  return (
    <div aria-hidden="true" className="relative mx-auto w-full max-w-[560px] lg:max-w-none">
      <div className="overflow-hidden rounded-frame border border-ink-100 bg-surface shadow-frame-lg">
        <div className="relative flex h-10 items-center gap-2 border-b border-ink-100 bg-surface-muted px-3.5">
          <span className="size-2.5 rounded-pill bg-ink-200" />
          <span className="size-2.5 rounded-pill bg-ink-200" />
          <span className="size-2.5 rounded-pill bg-ink-200" />
          <span className="absolute inset-x-0 text-center text-caption font-semibold text-ink-500">
            {mock.notificationApp}
          </span>
        </div>

        <div className="grid h-[380px] grid-cols-1 bg-surface-mock lg:grid-cols-[60px_1fr]">
          <MockRail
            workspaces={[
              { label: 'N', tint: 'brand' },
              { label: 'NE', tint: 'brand-soft' },
              { label: 'AL', tint: 'success' },
            ]}
            icons={['messages-square', 'kanban', 'library', 'sparkles', 'bell']}
          />

          <div className="flex min-w-0 flex-col text-left">
            <div className="flex h-12 flex-none items-center gap-2 border-b border-ink-100 bg-surface px-4 text-body font-bold text-ink-mock-900">
              <Icon name="hash" size={15} className="text-ink-400" />
              {mock.channel}
            </div>

            <div className="flex flex-1 flex-col justify-end gap-3.5 p-4">
              {mock.messages.map((message) => (
                <div key={message.text} className="flex items-end gap-2.5">
                  <MockAvatar initials={message.initials} tint={message.tint} />
                  <MockBubble direction="in" className="max-w-[80%]">
                    {message.text}
                  </MockBubble>
                </div>
              ))}
            </div>

            <div className="mx-4 mb-4 flex h-11 flex-none items-center gap-2 rounded-card-sm border border-ink-100 bg-surface px-3.5 text-caption text-ink-400">
              <span className="truncate">{mock.composer}</span>
              <Icon name="send-horizontal" size={15} className="ml-auto text-brand-600" />
            </div>
          </div>
        </div>
      </div>

      <div className="nx-float absolute top-14 right-3 w-[min(19rem,calc(100%-1.5rem))] lg:top-[100px] rounded-card border border-ink-100 bg-surface p-3.5 shadow-chat-panel lg:-right-4">
        <div className="flex items-start gap-3">
          <span className="grid size-9 flex-none place-items-center rounded-tile bg-brand-600 text-body font-bold text-white">
            N
          </span>
          <div className="min-w-0 flex-1 leading-[normal]">
            <div className="flex items-center justify-between gap-2 text-micro text-ink-400">
              <span className="font-semibold text-ink-mock-500">{mock.notificationApp}</span>
              <span>{mock.notificationTime}</span>
            </div>
            <div className="mt-1 text-caption font-semibold text-ink-mock-900">
              {mock.notificationTitle}
            </div>
            <div className="mt-0.5 text-caption text-ink-mock-500">{mock.notificationBody}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
